<script>
   /***************************************************************
    * Button                                                      *
    * --------------------                                        *
    * control element in form of rectangular button with text     *
    ***************************************************************/
</script>

<span class="wrapper">
<button tabindex="0" class="button-rect" on:click><slot></slot></button>
</span>

<style>
   button {
      background: #606060;
      display: inline-block;
      color: #fefefe;
      font-size: 0.9em;
      padding: 0.2em 0.5em;
      line-height: 1.5em;
      border: none;
      border-radius: 0.25em;
      box-shadow: none;
      text-align: center;
      border: 1px solid transparent;
   }

   button:hover {
      border-color: #6eb8ff;
      background: #6eb8ff20;
      color: #5086b9;
   }
</style>
